/**
 * The words of the validation study (piece 13, *Suggestions and the Check act*;
 * piece 31, *The validation study on a contacts read*; decision 5382): the Check
 * act, the Suggestions tile, Records Needing Data Review and the compare's
 * Suggested column, spread into the one string lookup.
 */
export const RECORD_CHECK_STRINGS = {
  'recordChecks.check': 'Check',
  'recordChecks.checking': 'Checking',
  'recordChecks.notChecked': 'Not checked yet',
  'recordChecks.lastChecked': 'Last checked {when}: {confirmed} confirmed, {unknown} unknown',
  'recordChecks.none': 'No suggestions stand for this record.',
  // Decision 6900: the Unknown count opens the fields the check found nothing for, each with its reason.
  'recordChecks.unknown.show': 'Show Unknown',
  'recordChecks.unknown.hide': 'Hide Unknown',
  'recordChecks.unknown.intro': 'Nothing was found for these fields, so there is nothing to accept.',
  'recordChecks.unknown.noSource': 'No source answered',
  'recordChecks.unknown.noAdapter': 'No lookup is switched on',
  'recordChecks.unknown.capReached': "This month's cap was reached",
  'recordChecks.unknown.checkFailed': 'The check failed',
  'recordChecks.noneHere': 'None here',
  'recordChecks.accept': 'Accept',
  'recordChecks.dismiss': 'Dismiss',
  // Decision 7150: a close employer is offered as the same company, and the answer says what it wrote.
  'recordChecks.sameCompany': 'Same Company',
  // T3028: the gold dot beside a person's name wherever people are listed.
  'recordChecks.dot.title': 'Has suggestions to look at',
  // T3066: the same dot beside a company's name on the Companies list and a company hit in search.
  'recordChecks.dot.companyTitle': 'This company has suggestions to look at',
  'recordChecks.sameCompanyLine': 'Same company as {company}',
  'recordChecks.sameCompanyDone': '“{name}” is now another name of {company}, so this employer reads Confirmed.',
  'recordChecks.here': 'Here',
  'recordChecks.suggested': 'Suggested',
  'recordChecks.on': 'on {label}',
  'recordChecks.requested': 'The check is running; its marks land within a minute or two.',
  'recordChecks.windowOnWebsite': 'Accepted in its own window on the website.',
  // Decision 7360: a company's Address row adds a site, and says so when the address on file is a post office box.
  'recordChecks.addAsNewSite': 'Add as a New Site',
  'recordChecks.postOfficeBox': 'The address on file is a post office box',
  'recordChecks.newSiteOnWebsite': 'Add as a New Site is in its own window on the website.',
  'recordChecks.employerHint': 'Suggested employer: {name}',
  'recordChecks.addressHint': 'Suggested address:',
  // Decision 6180: a history entry that folds into a row held, and a value the vendor assumes.
  'recordChecks.merge': 'Merge',
  'recordChecks.mergesInto': 'Merges into {label}',
  'recordChecks.assumed': 'Assumed',
  // Decision 7330: a Job History entry adds a title, adds an employment, or is a retirement that only offers to end the employment.
  'recordChecks.addsTitle': 'Adds a title under {label}',
  'recordChecks.addsEmployment': 'Adds an employment at {label}',
  'recordChecks.retiredFrom': 'Retired from {label}',
  'recordChecks.addTitle': 'Add Title',
  'recordChecks.addEmployment': 'Add Employment',
  'recordChecks.endEmploymentThere': 'End the Employment There',
  'recordChecks.choiceOnWebsite': 'This entry asks you to choose Keep Dates or Modify Dates and to confirm an end; do that on the website.',
  'recordChecks.jobMerge.retireSays': 'This declares the person retired from {company}. The employment record is ended on the retirement month, {month}, with {day} as its last day, and any login on it is deactivated.',
  // Decision 6440: a Job History Merge asks Keep Dates or Modify Dates, and names the months it leaves alone.
  'recordChecks.jobMerge.title': 'Merge Job History',
  'recordChecks.jobMerge.legend': 'The employment’s dates',
  'recordChecks.jobMerge.keep': 'Keep Dates: {line}',
  'recordChecks.jobMerge.modify': 'Modify Dates: {line}',
  'recordChecks.jobMerge.leftAlone': 'These months are left alone, because another employment or another title holds them or an ended employment is never reopened: {months}.',
  'recordChecks.jobMerge.choose': 'Choose Keep Dates or Modify Dates first.',
  'recordChecks.jobMerge.leftAloneDone': 'Merged. These months were left alone: {months}.',
  // Decision 6442: Modify Dates that ends an open employment confirms it in a second step.
  'recordChecks.jobMerge.modifyEnds': 'This entry has ended, so Modify Dates also ends the employment at {company}, after a confirmation.',
  'recordChecks.jobMerge.endTitle': 'End This Employment?',
  'recordChecks.jobMerge.endSays': 'This declares the person no longer at {company}. The employment record is ended on the entry’s end month, {month}, with {day} as its last day, and any login on it is deactivated.',
  'recordChecks.jobMerge.endTick': 'I confirm this person no longer works at {company}.',
  'recordChecks.jobMerge.tickFirst': 'Tick the confirmation first.',
  'recordChecks.jobMerge.confirm': 'Confirm',
  // Decision 6444: a row whose employment moved to another company re-pins before it merges.
  'recordChecks.jobMerge.repin': 'Re-pin',
  'recordChecks.jobMerge.repinTitle': 'Re-Pin Job History',
  'recordChecks.jobMerge.repinSays': 'The employment this entry folded into now sits at another company. Choose the employment it folds into, then merge as usual.',
  'recordChecks.jobMerge.repinLegend': 'Folds into',
  'recordChecks.jobMerge.repinMoved': 'As it stands now: {line}',
  'recordChecks.jobMerge.repinAt': 'At the entry’s company: {line}',
  'recordChecks.jobMerge.continue': 'Continue',
  'recordChecks.jobMerge.pickFirst': 'Choose an employment first.',
  'recordChecks.confidence.high': 'High',
  'recordChecks.confidence.medium': 'Medium',
  'recordChecks.confidence.low': 'Low',
  'recordChecks.review.title': 'Records Needing Data Review',
  'recordChecks.review.subtitle': 'People and companies a validation check suggested a change to.',
  'recordChecks.review.intro': 'Each record here holds a suggestion from a validation check that nobody has accepted or dismissed yet.',
  'recordChecks.review.empty': 'No record holds an undecided suggestion.',
  'recordChecks.review.record': 'Record',
  'recordChecks.review.suggestions': 'Suggestions',
  'recordChecks.review.newest': 'Newest',
  // Decision 6180: the Person page's Education, Other Skills and Profile tiles.
  'personHistory.education.empty': 'No school is held for this person.',
  'personHistory.education.modal.addTitle': 'Add School',
  'personHistory.education.modal.editTitle': 'Edit School',
  'personHistory.education.modal.subtitle': 'A school this person attended.',
  'personHistory.education.field.school': 'School',
  'personHistory.education.field.degree': 'Degree',
  'personHistory.education.field.fieldOfStudy': 'Field of study',
  'personHistory.education.field.startMonth': 'Start',
  'personHistory.education.field.endMonth': 'End',
  'personHistory.education.field.monthHint': 'A year, as 2015, or a year and month, as 2015-09.',
  'personHistory.education.field.linkedIn': 'School LinkedIn page',
  'personHistory.education.save': 'Save School',
  'personHistory.education.saveEdit': 'Save Changes',
  'personHistory.skills.empty': 'No other skill is held for this person.',
  'personHistory.skills.note': 'Skills a check found that the Skill catalog does not list. Nothing searches people by them.',
  'personHistory.skills.remove': 'Remove {skill}',
  'personHistory.profile.linkedIn': 'LinkedIn Page',
  'personHistory.profile.empty': 'No profile fact is held for this person.',
  'personHistory.profile.edit': 'Edit Profile Row',
  'personHistory.profile.editSubtitle': 'Correct the value as it should read. The row is then noted as yours, today.',
  'personHistory.profile.value': 'Value',
  'personHistory.profile.saveEdit': 'Save Changes',
  'personHistory.remove': 'Remove',
  'personHistory.removeTitle': 'Remove this row?',
  'personHistory.removeConsequence': 'It is deleted from this person. A later check can suggest it again.',
  // T2739: the nightly sweep's card on the Scheduled jobs page.
  'jobs.recordChecksSweep.label': 'Check bare names',
  'jobs.recordChecksSweep.purpose': 'Asks the outside lookups about people and companies whose names are bare, the oldest checked first, within the nightly limit.',
  'jobs.recordChecksSweep.limit': 'Records checked a night',
  // T2883: the words wholeAnswer.ts draws a history entry and its parts in.
  'wholeAnswer.month.january': 'January',
  'wholeAnswer.month.february': 'February',
  'wholeAnswer.month.march': 'March',
  'wholeAnswer.month.april': 'April',
  'wholeAnswer.month.may': 'May',
  'wholeAnswer.month.june': 'June',
  'wholeAnswer.month.july': 'July',
  'wholeAnswer.month.august': 'August',
  'wholeAnswer.month.september': 'September',
  'wholeAnswer.month.october': 'October',
  'wholeAnswer.month.november': 'November',
  'wholeAnswer.month.december': 'December',
  'wholeAnswer.span.fromTo': '{from} to {to}',
  'wholeAnswer.span.from': 'from {from}',
  'wholeAnswer.span.to': 'to {to}',
  'wholeAnswer.span.now': 'now',
  'wholeAnswer.titleAtEmployer': '{title} at {employer}',
  'wholeAnswer.label.employer': 'Employer',
  'wholeAnswer.label.title': 'Title',
  'wholeAnswer.label.website': 'Website',
  'wholeAnswer.label.linkedIn': 'LinkedIn page',
  'wholeAnswer.label.school': 'School',
  'wholeAnswer.label.degree': 'Degree',
  'wholeAnswer.label.fieldOfStudy': 'Field of study',
  'wholeAnswer.label.street': 'Street',
  'wholeAnswer.label.suite': 'Suite',
  'wholeAnswer.label.locality': 'City',
  'wholeAnswer.label.region': 'State',
  'wholeAnswer.label.postalCode': 'Postal code',
  'wholeAnswer.label.when': 'When',
  'wholeAnswer.monthProblem': 'A start or an end is a year, as 2015, or a year and month, as 2015-09.',
  // T2883: the Company page's Industry, Size and Founded rows.
  'recordPage.company.industry': 'Industry',
  'recordPage.company.mainPhone': 'Main phone',
  'recordPage.company.ein': 'Tax ID',
  // 🔒 Decision 7890: a vendor's Tax ID is the number its W-9 profile holds, changed on the Vendor tile; a person's number is not the company's.
  'recordPage.company.taxIdOnVendorTile': 'Changed on the Vendor tile',
  'recordPage.company.taxIdPersonNumber': 'None here; a person\'s number is on the W-9',
  'recordPage.company.dunsNumber': 'DUNS number',
  'recordPage.company.size': 'Size',
  'recordPage.company.founded': 'Founded',
  // Decision 7150: the company's other names, read on General Information and edited in the Company form.
  'recordPage.company.otherNames': 'Also known as',
  'companyOtherNames.heading': 'Also known as',
  'companyOtherNames.note': "These names are read only when a person's employer is checked; the company is never shown or searched by them.",
  'companyOtherNames.add': 'Add Name',
  'companyOtherNames.remove': 'Remove',
  'companyOtherNames.label': 'Other name',
  'recordPage.company.sizePeople': '{range} people',
} as const;
